export default ({ initial = null } = {}) => ({

    active: initial,

    toggleAccordion(value) {
        this.active = (value === this.active) ? null : value;
    },

    isActive(id) {
        return this.active === id;
    },

    trigger: (id) => ({
        ['x-bind:id']() {
            return 'trigger-' + id;
        },
        ['x-on:click']() {
            this.toggleAccordion(id);
        },
        ['x-bind:aria-expanded']() {
            return this.isActive(id);
        },
        ['x-bind:aria-controls']() {
            return 'panel-' + id;
        },
    }),

    panel: (id) => ({
        ['x-bind:id']() {
            return 'panel-' + id;
        },
        ['x-show']() {
            return this.isActive(id);
        },
        ['x-aria-labelled-by']() {
            return 'trigger-' + id;
        },
        ['x-bind:role']() {
            return this.isActive(id) ? 'region' : '';
        },
        ['x-collapse']: '',
    }),
})
